import connectivity_bg from './../static/connectivity.png';
import health from './../static/health.svg'
import connectivity from './../static/connectivity.svg'
import transactions from './../static/transaction.svg'
import public_sector from './../static/public_sector.svg'
import daresay_small from './../static/daresay_small.svg'
import public_sector_bg from './../static/public_sector_bg.png'
import sendIcon from './../static/send.svg'


export const images = {
  connectivity_bg,
  connectivity,
  health,
  transactions,
  public_sector,
  daresay_small,
  public_sector_bg,
  sendIcon
}



// WEBPACK FOOTER //
// ./src/utils/imageExporter.js